import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { PageHeader } from '../components/PageHeader';
import { ShieldAlertIcon, AlertTriangleIcon, ScaleIcon, HardHatIcon, CrosshairIcon, BookOpenIcon, ShieldCheckIcon } from 'lucide-react';
const lawPages = [{
  path: '/what-to-say-to-cops',
  icon: ShieldAlertIcon,
  label: 'What to Say to Cops',
  color: '#dc2626',
  description: 'Know your rights during stops'
}, {
  path: '/tips-after-crash',
  icon: AlertTriangleIcon,
  label: 'Tips After a Crash',
  color: '#f97316',
  description: 'Critical post-accident steps'
}, {
  path: '/horrible-laws',
  icon: ScaleIcon,
  label: '4 Horrible MI Laws',
  color: '#d4a853',
  description: 'Laws that frustrate riders'
}, {
  path: '/helmet-law',
  icon: HardHatIcon,
  label: 'MI Helmet Law',
  color: '#d4a853',
  description: 'When you can go helmetless'
}, {
  path: '/gun-laws',
  icon: CrosshairIcon,
  label: 'MI Gun Laws',
  color: '#d4a853',
  description: 'Carrying on your motorcycle'
}, {
  path: '/motorcycle-laws',
  icon: BookOpenIcon,
  label: 'MI Motorcycle Laws',
  color: '#d4a853',
  description: 'General regulations'
}, {
  path: '/insurance',
  icon: ShieldCheckIcon,
  label: 'Recommended Insurance',
  color: '#3b82f6',
  description: 'Protect yourself properly'
}];
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.06
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0
  }
};
export function LawsHub() {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-[#0a0a0a] safe-bottom" data-id="element-291">
      <PageHeader title="Michigan Laws" subtitle="Legal resources for riders" showBack={false} data-id="element-292" />

      <main className="px-4 py-6" data-id="element-293">
        <motion.div className="space-y-3" variants={container} initial="hidden" animate="show" data-id="element-294">
          {lawPages.map(page => {
          const Icon = page.icon;
          return <motion.button key={page.path} variants={item} onClick={() => navigate(page.path)} className="w-full flex items-center gap-4 bg-[#1a1a1a] border border-[#2a2a2a] rounded-2xl p-4 text-left active:bg-[#252525]" whileTap={{
            scale: 0.98
          }} data-id="element-295">
                <div className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0" style={{
              backgroundColor: `${page.color}15`
            }} data-id="element-296">
                  <Icon className="w-6 h-6" style={{
                color: page.color
              }} data-id="element-297" />
                </div>
                <div className="flex-1 min-w-0" data-id="element-298">
                  <p className="font-semibold text-white" data-id="element-299">{page.label}</p>
                  <p className="text-sm text-[#a3a3a3]" data-id="element-300">{page.description}</p>
                </div>
                <div className="text-[#a3a3a3]" data-id="element-301">→</div>
              </motion.button>;
        })}
        </motion.div>
      </main>
    </div>;
}